<div class="loading-spinner">
    <img [src]="imageUrl" alt="Loading...">
  </div>